<template>
  <div class="g-content">
    <div class="g-content-filter">
      <div class="g-content-filter-main">
        <h3>{{ $t('menu_interface_title') }}</h3>

        <a-button
          type="primary"
          @click="$refs.menuUpdate.show()"
          icon="plus"
          v-auth="['auth_menu_add']"
        >
          {{ $t('menu_btn_add') }}
        </a-button>
      </div>
    </div>

    <div class="g-content-main common-filter-main menu-main-content">
      <NetworkError v-if="networkError" style="margin-top:0;" />
      <div style="height: 100%;" v-else>
        <div class="menu-main" v-if="menuList && menuList.length">
          <div class="menu-side">
            <a-directory-tree
              :tree-data="menuList"
              :expandedKeys.sync="expandedKeys"
              :selectedKeys="defaultSelectedKeys"
              @click="onSelect"
              style="width:200px;"
              :expandAction="false"
            >
            </a-directory-tree>
          </div>
          <div class="menu-content">
            <Loading :show="loading" v-if="loading" />
            <div v-else>
              <div class="menu-basic" v-if="currentMenuInfo">
                <div class="menu-content-title">
                  <span>{{ currentMenuInfo.name }} </span>
                  <a-button
                    type="primary"
                    size="small"
                    @click="$refs.menuUpdate.show(currentMenuInfo)"
                    icon="edit"
                    v-auth="['auth_menu_edit']"
                  >
                    {{ $t('com_btn_edit') }}
                  </a-button>
                  <a-button
                    type="danger"
                    size="small"
                    @click="deleteMenu(currentMenuInfo)"
                    icon="delete"
                    v-auth="['auth_menu_delete']"
                  >
                    {{ $t('com_btn_delete') }}
                  </a-button>
                </div>
                <ul class="menu-basic-list">
                  <li>
                    <label>{{ $t('menu_interface_form_url') }}:</label
                    ><span>{{ currentMenuInfo.url }}</span>
                  </li>
                  <li>
                    <label>{{ $t('menu_interface_form_auth_name') }}:</label
                    ><span>
                      {{ currentMenuInfo.authName }}
                      <a-icon
                        type="copy"
                        @click="copyContent(`#auth_menu_${currentMenuInfo.authName}`)"
                        :data-clipboard-text="`${currentMenuInfo.authName}`"
                        data-clipboard-action="copy"
                        :id="`auth_menu_${currentMenuInfo.authName}`"
                        title="Copy"
                        style="color:#ccc"
                      />
                    </span>
                  </li>
                  <li>
                    <label>{{ $t('com_table_id') }}:</label><span>{{ currentMenuInfo.id }}</span>
                  </li>
                  <li>
                    <label>{{ $t('com_table_status') }}:</label>
                    <span v-if="currentMenuInfo.disabled" style="color:#f00">
                      {{ $t('com_table_disabled') }}
                    </span>
                    <span class="g-refresh-status" style="position:relative;top:3px;" v-else>
                      {{ $t('com_form_enabled') }}
                      <Icon
                        type="status_ok"
                        class="success"
                        v-if="currentMenuInfo.common"
                        style="margin-left:5px;"
                      />
                    </span>
                  </li>
                  <li>
                    <label>{{ $t('menu_table_parent_id') }}:</label
                    ><span>{{ currentMenuInfo.parentId }}</span>
                  </li>

                  <li v-if="menuObject[currentMenuInfo.parentId]">
                    <label>{{ $t('menu_table_parent_name') }}:</label
                    ><span>{{ menuObject[currentMenuInfo.parentId].name }}</span>
                  </li>

                  <li>
                    <label>{{ $t('com_table_created_time') }}:</label
                    ><span>{{ currentMenuInfo.createTime | formatDate }}</span>
                  </li>
                  <li>
                    <label>{{ $t('menu_form_sort') }}:</label
                    ><span>{{ currentMenuInfo.sort }}</span>
                  </li>

                  <li v-if="currentMenuInfo.remark" style="width:100%">
                    <label>{{ $t('com_form_remark') }}:</label
                    ><span>{{ currentMenuInfo.remark }}</span>
                  </li>
                </ul>
              </div>

              <div class="menu-content-title">
                <span>{{ $t('interface_title') }}</span>
                <a-button
                  type="primary"
                  size="small"
                  @click="showInterfaceUpdate()"
                  icon="plus"
                  v-auth="['auth_interface_add']"
                >
                  {{ $t('interface_btn_add') }}
                </a-button>
              </div>

              <div class="g-table">
                <a-table
                  :columns="columns"
                  :data-source="interfaceList"
                  :pagination="false"
                  :rowKey="(_text, index) => index"
                  bordered
                  size="small"
                >
                  <!-- 名称 -->
                  <template slot="Name" slot-scope="text, record">
                    <div
                      @click="showInterfaceUpdate(record)"
                      style="text-decoration: underline;cursor: pointer;"
                      :style="record.common ? 'color:green' : ''"
                      :title="record.common ? $t('menu_interface_default_auth') : ''"
                      class="g-table-text"
                    >
                      {{ text }}
                    </div>
                  </template>

                  <!-- 权限值 -->
                  <template slot="authName" slot-scope="text">
                    <div class="g-table-text">
                      {{ text }}
                      <a-icon
                        type="copy"
                        @click="copyContent(`#auth_menu_${text}`)"
                        :data-clipboard-text="`${text}`"
                        data-clipboard-action="copy"
                        :id="`auth_menu_${text}`"
                        title="Copy"
                        style="color:#ccc"
                      />
                    </div>
                  </template>

                  <!-- 权限值 -->
                  <template slot="url" slot-scope="text">
                    <div class="g-table-text">
                      {{ text }}
                    </div>
                  </template>

                  <template slot="disabled" slot-scope="text, record">
                    <span v-if="text" style="color:#f00">{{ $t('com_form_disabled') }}</span>
                    <span class="g-refresh-status" style="position:relative;top:3px;" v-else>
                      {{ $t('com_form_enabled')
                      }}{{ record.common ? `${$t('menu_interface_default_auth')}` : '' }}
                      <Icon
                        type="status_ok"
                        class="success"
                        v-if="record.common"
                        style="margin-left:5px;"
                      />
                    </span>
                  </template>

                  <template slot="createTime" slot-scope="text">
                    {{ text | formatDate }}
                  </template>

                  <!-- 操作 -->
                  <template slot="Action" slot-scope="text, record">
                    <a-button
                      type="primary"
                      size="small"
                      @click="showInterfaceUpdate(record)"
                      icon="edit"
                      v-auth="['auth_interface_edit']"
                    >
                      {{ $t('com_btn_edit') }}
                    </a-button>

                    <a-button
                      type="danger"
                      size="small"
                      @click="deleteInterface(record)"
                      icon="delete"
                      v-auth="['auth_interface_delete']"
                    >
                      {{ $t('com_btn_delete') }}
                    </a-button>
                  </template>
                </a-table>
              </div>
            </div>
          </div>
        </div>
        <Empty v-else />
      </div>
    </div>

    <!-- 菜单添加/编辑 -->
    <MenuUpdate
      ref="menuUpdate"
      :callback="
        menu => {
          if (menu) {
            this.getAllMenuList(menu.id);
            this.getMenuInfo(menu.id);
          } else {
            this.getAllMenuList();
          }
        }
      "
      :menuInfo="currentMenuInfo"
      :allMenu="menuList"
    />

    <!-- 接口添加/编辑 -->
    <InterfaceUpdate
      ref="interfaceUpdate"
      :callback="getMenuInfo"
      :allMenu="menuList"
      v-if="currentMenuInfo"
    />
  </div>
</template>
<script>
import * as API from '@/api/system/role';
import MenuUpdate from './components/menuUpdate.vue';
import InterfaceUpdate from './components/interfaceUpdate.vue';
import { makeTree } from '@/libs/utils';
import { copyContent } from '@/libs/utils';
import { mapGetters } from 'vuex';
import { dragTableToScroll } from '@/libs/utils';

export default {
  components: {
    MenuUpdate,
    InterfaceUpdate,
  },
  data() {
    return {
      copyContent,
      form: {},
      rules: {},
      menuList: [],
      menuObject: [],
      expandedKeys: [],
      defaultSelectedKeys: [],
      // 当前菜单信息
      currentMenuInfo: null,
      loading: false,

      // infterface表头
      columns: [
        {
          title: this.$t('com_table_id'),
          align: 'center',
          dataIndex: 'id',
          width: 60,
        },
        {
          title: this.$t('interface_form_name'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'Name' },
        },

        {
          title: this.$t('menu_interface_form_auth_name'),
          dataIndex: 'authName',
          scopedSlots: { customRender: 'authName' },
        },
        {
          title: this.$t('menu_interface_form_url'),
          dataIndex: 'url',
          scopedSlots: { customRender: 'url' },
        },

        {
          title: this.$t('interface_form_method'),
          dataIndex: 'method',
        },

        {
          title: this.$t('com_table_status'),
          dataIndex: 'disabled',
          scopedSlots: { customRender: 'disabled' },
          width: 100,
        },

        {
          title: this.$t('com_form_description'),
          dataIndex: 'description',
        },

        {
          title: this.$t('com_table_created_time'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
        },
      ],

      interfaceList: [],
      networkError: false,
      horizontalScroll: null,
    };
  },
  computed: {
    ...mapGetters(['authList', 'isSuperAdmin']),
  },
  created() {
    this.getAllMenuList();

    // 操作
    if (
      this.authList.includes('auth_interface_edit') ||
      this.authList.includes('auth_interface_delete') ||
      this.isSuperAdmin
    ) {
      this.columns.push({
        title: this.$t('com_table_operation'),
        dataIndex: 'Action',
        scopedSlots: { customRender: 'Action' },
      });
    }
  },
  beforeDestroy() {
    this.horizontalScrollDestory();
  },
  methods: {
    // 获取菜单列表
    getAllMenuList(id) {
      this.networkError = false;
      API.AllMenuList()
        .then(res => {
          // 排序
          const sortData = res.data.sort((a, b) => a.sort - b.sort);
          const treeObj = makeTree({ data: sortData || [] });
          this.expandedKeys = treeObj.key;
          this.defaultSelectedKeys = [id ? `${id}` : treeObj.key[0]];
          this.menuList = treeObj.array;
          this.menuObject = treeObj.object;

          // 获取第一个菜单的详情
          if (id) {
            this.getMenuInfo(id);
          } else if (sortData[0]) {
            this.getMenuInfo(sortData[0].id);
          }
        })
        .catch(() => {
          this.networkError = true;
        })
        .finally(() => {
          this.$store.commit('setPageLoading', false);
        });
    },

    // 获取当前菜单详情
    getMenuInfo(id) {
      this.loading = true;
      API.MenuDetail({ id: id || this.currentMenuInfo.id })
        .then(res => {
          if (res.code === 0) {
            this.currentMenuInfo = res.data?.menu || [];
            this.interfaceList = res.data?.interfaces || [];
          }
        })
        .finally(() => {
          this.loading = false;

          // 表格横向滚动注册
          this.$nextTick(() => {
            this.horizontalScrollDestory();
            this.horizontalScroll = dragTableToScroll(
              document.querySelector('.ant-table-body'),
              document.querySelector('.ant-table-tbody table')
            );
          });
        });
    },
    // 横向滚动事件注销
    horizontalScrollDestory() {
      if (this.horizontalScroll) {
        this.horizontalScroll.destroy();
      }
    },

    onSelect(keys, event) {
      const value = keys[0] || event.value;
      this.defaultSelectedKeys = [String(value)];
      this.getMenuInfo(Number(value));
    },

    showInterfaceUpdate(record) {
      this.$refs.interfaceUpdate.show(record, record ? null : this.currentMenuInfo);
    },

    // 删除菜单
    deleteMenu(record) {
      // 菜单下面有接口时，不可直接删除
      if (this.interfaceList && this.interfaceList.length) {
        this.$message.error(this.$t('menu_delete_error'));
        return;
      }

      const h = this.$createElement;
      this.$confirm({
        title: this.$t('menu_confirm_delete_title'),
        content: h('div', {}, [
          h('p', this.$t('menu_confirm_delete_content_name', { name: record.name })),
          h(
            'p',
            this.$t('menu_confirm_delete_content_url', {
              name: record.url || '',
            })
          ),
        ]),
        centered: true,
        onOk: () => {
          this.deleteLoading = true;
          this.$store.commit('setFreeze', this.$t('com_ongoing_delete'));
          API.MenuDelete({ menuId: record.id })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_delete_success'));

                // 重新获取列表
                this.getAllMenuList();
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
      });
    },

    // 删除接口
    deleteInterface(record) {
      const _this = this;
      const h = this.$createElement;
      this.$confirm({
        title: this.$t('interface_confirm_delete_title'),
        content: h('div', {}, [
          h(
            'p',
            this.$t('interface_confirm_delete_content_name', {
              name: record.name,
            })
          ),
          h(
            'p',
            this.$t('interface_confirm_delete_content_url', {
              name: record.url || '',
            })
          ),
        ]),
        centered: true,
        onOk: () => {
          this.deleteLoading = true;
          this.$store.commit('setFreeze', this.$t('com_ongoing_delete'));
          API.InterfaceDel({ interfaceId: record.id })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_delete_success'));

                // 重新获取列表
                this.getMenuInfo();
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.g-content {
  padding: 0;

  .g-content-main {
    padding-left: 0;
  }
  .g-content-main.menu-main-content {
    overflow-y: hidden !important;
  }

  .menu-main {
    display: flex;
    height: 100%;
    ::v-deep .menu-side {
      padding: 0 20px 10px 20px;
      box-sizing: border-box;
      border-right: #eee solid 1px;
      overflow-y: auto;
      .ant-tree-treenode-selected {
        > span {
          color: #fff !important;
          &.ant-tree-node-content-wrapper {
            &::before {
              background: #1838d9 !important;
              border-radius: 3px;
            }
          }
        }
      }

      .ant-tree-treenode-disabled {
        span {
          color: #999;
        }
      }
    }

    .menu-content {
      flex: 1;
      padding: 15px 20px;
      overflow-y: auto;

      .menu-content-title {
        display: flex;
        align-items: center;
        span {
          font-size: 18px;
          margin-right: 30px;
          color: #000;
        }
        button {
          margin-right: 15px;
        }

        padding-bottom: 20px;
      }

      .menu-basic {
        .menu-basic-list {
          padding-bottom: 20px;
          display: flex;
          width: 800px;
          flex-wrap: wrap;
          li {
            padding: 7px 0;
            display: flex;
            width: 300px;
            max-width: 50%;
            font-size: 14px;

            label {
              color: #999;
              padding-right: 10px;
            }
          }
        }
      }
    }
  }
}
</style>
